import { useState, useEffect } from 'react';
import { Terminal } from 'lucide-react';
import { META, ROUTES } from './data';

// Mercurial header — terminal command bar. NOT a transparent navbar.
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`fixed top-0 inset-x-0 z-40 bg-[#0A0E14] border-b transition-all ${scrolled ? 'border-[#06D6A0]/25 shadow-[0_8px_32px_rgba(0,0,0,0.4)]' : 'border-[#1A2230]'}`}>
      {/* Window-chrome bar like a terminal */}
      <div className="border-b border-[#1A2230] px-5 py-1.5 flex items-center gap-2 font-mono text-[10px] text-[#5F7184]">
        <span className="w-2.5 h-2.5 rounded-full bg-[#FF5F57]"></span>
        <span className="w-2.5 h-2.5 rounded-full bg-[#FEBC2E]"></span>
        <span className="w-2.5 h-2.5 rounded-full bg-[#28C840]"></span>
        <span className="ml-2 text-[#5F7184]/70">~/{META.brand}/main · zsh · UTF-8 · 132×42</span>
        <span className="ml-auto hidden sm:inline text-[#06D6A0]">● connected</span>
      </div>
      <div className="max-w-[1500px] mx-auto px-5 lg:px-8 py-3 grid grid-cols-[auto_1fr_auto] items-center gap-6">
        <button onClick={() => setPage('home')} data-testid="mc-logo" className="flex items-center gap-2 text-left">
          <Terminal className="w-4 h-4 text-[#06D6A0]" strokeWidth={2.2} />
          <span className="font-mono text-base text-[#E6EDF3] lowercase">{META.brand}</span>
          <span className="font-mono text-[10px] text-[#5F7184]">v8.4.2</span>
        </button>
        <nav className="hidden md:flex items-center justify-center gap-2 font-mono text-xs">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`mc-nav-${r.id}`} className={`px-3 py-1.5 transition-colors rounded-sm ${page === r.id ? 'bg-[#06D6A0]/15 text-[#06D6A0] border border-[#06D6A0]/30' : 'text-[#5F7184] hover:text-[#E6EDF3] hover:bg-[#1A2230]'}`}>
              <span className="text-[#5F7184]">$</span> {r.label}
            </button>
          ))}
        </nav>
        <button onClick={() => setPage('pricing')} data-testid="mc-header-trial" className="font-mono text-xs bg-[#06D6A0] text-[#0A0E14] px-4 py-2 hover:bg-[#5BFFC9] transition-colors">$ start --free</button>
      </div>
    </header>
  );
}
